import { ControlValueAccessor, FormControl, ControlContainer, FormArray, FormGroup } from '@angular/forms';
import { Input, OnInit, Optional, Host, SkipSelf, ElementRef, Renderer, ViewChild, Output, EventEmitter } from '@angular/core';

import { getValidatorsFromControl } from 'src/app/main/_utils/general-util';
import { ItmAbstractElementRef } from './itm-abstract-element-ref';
import { AutocompleteService } from 'src/app/root/_services/autocomplete.service';
import { GoogleMapsService } from 'src/app/root/_services/google-maps.service';
import { TranslateService } from '@ngx-translate/core';
import { ItmTelephoneItem } from './itm-telephone/itm-telephone.component';

export abstract class ItmAbstractControl<T> extends ItmAbstractElementRef implements ControlValueAccessor, OnInit {

	@Input() formControlName: string;
	@Input() name: string;
	@Input() label: string;
	@Input() cssClass: string;
	@Input() id: string = this.generateRandomId();
	@Input() showValidationOnlyWhenTouched: boolean = false;
	@Input() forceValidation = false;
	@Input() labelAction: string;
	@Input() cssLabelAction: string;

	@Output() labelActionClick: EventEmitter<any> = new EventEmitter<any>();

	onChange: any = (_: any) => { };
	onTouched: any = () => { };
	disabled: boolean = false;
	control: FormControl;
	validators: any;
	val: T;

	abstract getControlRef();

	constructor(
		@Optional() @Host() @SkipSelf() private controlContainer: ControlContainer,
		el: ElementRef,
		protected _renderer: Renderer,
		protected autocompleteService: AutocompleteService,
		protected googleMapsService: GoogleMapsService,
		protected translateService: TranslateService
	) {
		super(el);
	}

	_labelActionClick(event) {
		this.labelActionClick.emit(event);
	}

	ngOnInit() {
		if (this.controlContainer.control) {
			if (this.controlContainer.control instanceof FormGroup) {
				this.control = <FormControl>this.controlContainer.control.get(this.formControlName);
				this.validators = getValidatorsFromControl(this.control);
			}
			else if (this.controlContainer.control instanceof FormArray) {
				this.control = <FormControl>this.controlContainer.control.controls[this.formControlName];
				this.validators = getValidatorsFromControl(this.control);
			}
		}
	}

	generateRandomId(): string {
		return (Math.round((Math.random() * 10000)) * Date.now() + Math.round((Math.random() * 10000))) + "";
	}

	isRequired(): boolean {
		return true;
	}

	validate(c: FormControl): boolean {
		this.control = c;
		return c.valid;
	}

	showValidationMessage(): boolean {
		//return this.control ? this.control.invalid && (!this.showValidationOnlyWhenTouched || (this.control.touched && this.showValidationOnlyWhenTouched)) : false;
		return this.control ? this.control.invalid && this.forceValidation : false;
	}
	// get value(): T {
	// 	return this.val;
	// }

	// set value(v) {
	// 	this.val = v;
	// 	this.onChange(v);
	// 	this.onTouched();
	// }

	/**
		 * Writes a new value to the element.
		 */
	writeValue(v: T): void {
		this.val = v;
		if (this.getControlRef())
			this._renderer.setElementProperty(this.getControlRef().nativeElement,
				'value', this.val);
	}
	/**
	 * Registers a callback function that should be called when
	 * the control's value changes in the UI.
	 */
	registerOnChange(fn: any): void {
		this.onChange = fn;
	}
	/**
	 * Registers a callback function that should be called when
	 * the control receives a blur event.
	 */
	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}
	/**
	 * This function is called by the forms API when
	 * the control status changes to or from "DISABLED".
	 */
	setDisabledState?(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}



}
